(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["activity-header"] && !Shopify.designMode) return;
  try {
    
  var ActivityHeader = class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const button = this.querySelector('.header-button');
      if (button) {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', 'UkPCfK']);
        });
      }
    }
  };
  if (!window.customElements.get('activity-header')) {
    window.customElements.define('activity-header', ActivityHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["activity-main-slide"] && !Shopify.designMode) return;
  try {
    
  var PromptMainSlider = class extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    isMobile() {
      const mediaQuery = '(max-width: 768px)';
      const mql = window.matchMedia(mediaQuery);

      if (mql.matches) {
        return true;
      } else {
        return false;
      }
    }

    initSwiper() {
      let id = this.getAttribute('section-id');
      let className = '.pc-swiper-' + id;
      let paginationClassname = '.pc-pagination-' + id;
      if (this.isMobile()) {
        className = '.mobile-swiper-' + id;
        paginationClassname = '.mobile-pagination-' + id;
      }
      const speed = this.dataset.speed
      this.swiper = new Swiper(className, {
        loop: true,
        autoplay:
         {
          delay: speed * 1000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        spaceBetween: 20,
        slidesPerView: 'auto',
        pagination: {
          el: paginationClassname, // 指定分页器容器的选择器
          clickable: true,        // 允许点击小圆点切换幻灯片
        },
        on: {
          slideChangeTransitionEnd: function () {
            // 获取当前激活的slide
            const activeSlide = this.slides[this.activeIndex];
            // 获取按钮文本
            const btnText = activeSlide.getAttribute('data-btntext');
            // 获取对应的button元素并更新内容
            const button = activeSlide.closest('.swiper').querySelector('.prompt-button span');
            if (button && btnText) {
              button.textContent = btnText;
            }
          }
        }
      });
    }

    initBuyButton() {
      const buyButtons = this.querySelectorAll('button.prompt-button');
      const _this = this;
      for(const buyButton of buyButtons){
        buyButton.addEventListener('click', function () {
          const curr = _this.swiper.slides[_this.swiper.activeIndex];
          const link = curr.getAttribute('link');
          window.location.href = link;
        });
      }
    }

    connectedCallback() {
      this.initSwiper();
      this.initBuyButton();
    }
  };
  if (!window.customElements.get('activity-main-slide')) {
    window.customElements.define('activity-main-slide', PromptMainSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["activity-menu"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const menuButtons = document.querySelectorAll('.lj-menu .menu-button');
    menuButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'UkPCfK']);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["activity-picture-redirect"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('activity-picture-redirect')) {
    class ActivityPictureRedirect extends HTMLElement {
      constructor() {
        super();
        this.buttonsWrapper = this.querySelector('.feature-buttons-wrapper');
        this.imageContainers = this.querySelectorAll('.feature-image-container');
      }

      connectedCallback() {
        if (!this.buttonsWrapper || !this.imageContainers) return;
        this.initButtonEvent();
        this.setInitialState();
      }

      setInitialState() {
        const firstButton = this.buttonsWrapper.querySelector('.feature-button');
        if (firstButton) {
          firstButton.classList.add('active');
          const initialBlockId = firstButton.getAttribute('data-block-id');
          this.showTargetImage(initialBlockId);
        } else {
           if(this.imageContainers.length > 0) {
              this.imageContainers[0].classList.add('active');
           }
        }
      }

      clearActiveButtonStatus() {
        const buttons = this.buttonsWrapper.querySelectorAll('.feature-button');
        buttons.forEach(btn => btn.classList.remove('active'));
      }

      clearImageActiveStatus() {
        this.imageContainers.forEach(container => container.classList.remove('active'));
      }

      showTargetImage(blockId) {
        if (!blockId) return;
        this.clearImageActiveStatus();
        const targetImage = this.querySelector(`#image-${blockId}`);
        if (targetImage) {
          targetImage.classList.add('active');
        }
      }

      initButtonEvent() {
        this.buttonsWrapper.addEventListener('click', (event) => {
          const clickedButton = event.target.closest('.feature-button');
          if (!clickedButton || clickedButton.classList.contains('active')) {
            return;
          }

          this.clearActiveButtonStatus();
          clickedButton.classList.add('active');
          const block_id = clickedButton.getAttribute('data-block-id');
          this.showTargetImage(block_id);
        });
      }
    }
    window.customElements.define('activity-picture-redirect', ActivityPictureRedirect);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["activity-product-card"] && !Shopify.designMode) return;
  try {
    
  function ljThrottle(func, delay) {
    let timer = null;
    return function () {
      const context = this;
      const args = arguments;
      if (!timer) {
        timer = setTimeout(() => {
          func.apply(context, args);
          timer = null;
        }, delay);
      }
    };
  }
  class PromptProductCard extends HTMLElement {
    constructor() {
      super();
      // No swipers needed for this card logic
      // this.swipers = new Map();
      this.priceWrappers = null; // Keep if price offer logic is still used elsewhere
      this.minDiff = 56; // Keep if price offer logic is still used
       // Use arrow function to preserve 'this' context or bind later
       this.handleSizeChange = this.handleSizeChange.bind(this);
       this.init = this.init.bind(this); // Ensure init uses correct 'this'

       if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.init);
       } else {
        this.init(); // Already loaded
       }
    }

    connectedCallback() {
        // Init is called via DOMContentLoaded or directly in constructor
        console.log('activity-product-card connected');
    }

    init() {
      console.log('PromptProductCard init called.');
      // Note: 'this' refers to the <activity-product-card> element
      const productCards = this.querySelectorAll('li[data-product-id]');
      console.log('Found product cards inside custom element:', productCards.length);

      if (productCards.length === 0) {
        console.warn('No product cards found within activity-product-gallery.');
        return;
      }

      productCards.forEach((card) => {
        const productId = card.dataset.productId;
        const swatchesContainer = card.querySelector('[data-color-swatches]');
        const variantJsonScript = card.querySelector(`script[data-variant-json="${productId}"]`);
        let variantsData = [];

        console.log(`Processing card ${productId}`);

        if (variantJsonScript) {
          try {
            variantsData = JSON.parse(variantJsonScript.textContent);
            console.log(`Parsed ${variantsData.length} variants for product ${productId}`);
            if(variantsData.length === 0){
                 console.warn(`No variant data parsed for product ${productId}`);
                 return; // Skip if no variants
            }
          } catch (e) {
            console.error(`Error parsing variant JSON for product ${productId}:`, e);
            return; // Skip this card
          }
        } else {
          console.warn(`Variant JSON script not found for product ${productId}`);
          return; // Skip this card
        }

        // --- Initial Card State Setup ---
        const productCardElement = card.querySelector('.product-gallery-card');
        if (!productCardElement) {
          console.error('Could not find .product-gallery-card inside li for product', productId);
          return; // Skip if card structure is wrong
        }

        // Find the initially active swatch (set by Liquid)
        const initialActiveSwatch = swatchesContainer?.querySelector('.color-swatch.active');
        const initialVariantId = initialActiveSwatch?.dataset.variantId;

        let initialVariant = null;
        if (initialVariantId) {
            initialVariant = variantsData.find((v) => v.id == initialVariantId);
            if (initialVariant) {
                console.log(`Initial update for product ${productId} with variant ${initialVariantId} (from active swatch)`);
                this.updateCard(productCardElement, initialVariant);
            } else {
                 console.warn(`Could not find initial variant data for active swatch ID: ${initialVariantId} in product ${productId}. Falling back.`);
                 initialVariant = variantsData[0]; // Fallback to first
                 if(initialVariant) this.updateCard(productCardElement, initialVariant);
            }
        } else if (variantsData.length > 0) {
            console.warn(`No active swatch found for product ${productId}, using first variant as initial.`);
            initialVariant = variantsData[0]; // Fallback to first variant if none active
            this.updateCard(productCardElement, initialVariant);
        } else {
             console.error(`No variants available to set initial state for product ${productId}`);
        }


        // --- Add Event Listeners ---
        if (swatchesContainer && variantsData.length > 0) {
          console.log(`Adding click listener to swatches for product ${productId}`);
          // Use bind to ensure 'this' inside the handler refers to the class instance
          swatchesContainer.addEventListener(
            'click',
            this.handleSwatchClick.bind(this, variantsData)
          );
        } else {
          console.log(`No swatches container or no variants for product ${productId}, listener not added.`);
        }
      });

       // Init resize listener if price offer logic is used
      // this.priceWrappers = this.querySelectorAll('.price-offers-wrapper'); // Adjust selector if needed
      // if (this.priceWrappers && this.priceWrappers.length > 0) {
      //   this.initEvent();
      // }
    }

    handleSwatchClick(variantsData, event) {
      const targetSwatch = event.target.closest('.color-swatch');
      if (!targetSwatch) return; // Exit if click wasn't on a swatch

      // Prevent re-updating if already active
      if (targetSwatch.classList.contains('active')) {
        console.log('Clicked swatch is already active.');
        return;
      }


      const clickedVariantId = targetSwatch.dataset.variantId;
      const swatchesContainer = targetSwatch.closest('[data-color-swatches]'); // Find container again
      const productCardElement = targetSwatch.closest('.product-gallery-card'); // Find card element

      console.log(`Swatch clicked! Variant ID: ${clickedVariantId}`);

      const selectedVariantData = variantsData.find((v) => v.id == clickedVariantId);

      if (selectedVariantData && productCardElement && swatchesContainer) {
        console.log('Found variant data:', selectedVariantData);

        // Update active class
        swatchesContainer.querySelectorAll('.color-swatch').forEach((sw) => sw.classList.remove('active'));
        targetSwatch.classList.add('active');
        console.log('Active class updated.');

        // Update the card content using the class method
        this.updateCard(productCardElement, selectedVariantData);

        // --- Update Modal Button OnClick ---
        const modalButton = productCardElement.querySelector('.product-gallery-card__button');
        const productHandle = modalButton?.getAttribute('onclick')?.match(/'([^']+)'/)?.[1]; // Extract handle
        const productType = modalButton?.getAttribute('onclick')?.match(/'([^']+)',\s*\d+,\s*'([^']*)'/)?.[2]; // Extract type if present

        if (modalButton && productHandle) {
            const newOnClick = `window.openProductModal('${productHandle}', ${selectedVariantData.id}${productType ? `, '${productType}'` : ''})`;
            console.log('Updating modal button onclick to:', newOnClick);
            modalButton.setAttribute('onclick', newOnClick);
        } else {
             console.warn('Could not update modal button onclick attribute.');
        }


      } else {
        console.warn(`Could not find variant data, card element, or swatches container for ID: ${clickedVariantId}`);
      }
    }

    // --- Helper: Format Money (Class method) ---
    formatMoney(cents, format) {
      if (typeof cents == 'string') {
        cents = cents.replace('.', '');
      }
       if (cents === null || typeof cents === 'undefined') {
           return ''; // Return empty string for null/undefined price
       }
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
       // Use Shopify's format if available, otherwise a sensible default
      const formatString = format || window.Shopify?.currency?.money_format || '${{amount}}';

      function defaultOption(opt, def) {
        return typeof opt == 'undefined' ? def : opt;
      }
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) {
          return "0"; // Return "0" instead of 0
        }
        number = (Number(number) / 100.0).toFixed(precision); // Ensure number conversion
        const parts = number.split('.');
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const centsValue = parts[1] ? decimal + parts[1] : ''; // Use different var name
        return dollars + centsValue;
      }
       try {
            let amountType = formatString.match(placeholderRegex)?.[1] || 'amount'; // Default to 'amount'
             switch (amountType) {
                 case 'amount':
                    value = formatWithDelimiters(cents, 2); break;
                 case 'amount_no_decimals':
                    value = formatWithDelimiters(cents, 0); break;
                 case 'amount_with_comma_separator':
                     value = formatWithDelimiters(cents, 2, '.', ','); break;
                 case 'amount_no_decimals_with_comma_separator':
                     value = formatWithDelimiters(cents, 0, '.', ','); break;
                 // Add other Shopify formats if needed
                 default: value = formatWithDelimiters(cents, 2);
            }
            return formatString.replace(placeholderRegex, value);
        } catch (e) {
             console.error("Error formatting money:", e);
             // Fallback to simple formatting if complex regex fails
             return formatWithDelimiters(cents, 2);
        }
    }

    // --- Helper: Calculate Discount (Class method) ---
    calculateDiscount(price, compareAtPrice) {
      console.log(`Calculating discount: Price=${price}, CompareAtPrice=${compareAtPrice}`);
      const numPrice = Number(price);
      const numCompareAtPrice = Number(compareAtPrice);

      // Ensure compare_at_price is valid and greater than price
      if (
        numCompareAtPrice &&
        !isNaN(numCompareAtPrice) &&
        numPrice &&
        !isNaN(numPrice) &&
        numCompareAtPrice > numPrice
      ) {
        const diff = numCompareAtPrice - numPrice;
        const discount = Math.floor((diff * 100) / numCompareAtPrice);
        console.log('Discount calculated:', discount);
        return discount;
      }
      console.log('No discount applicable or invalid prices.');
      return 0;
    }

    // --- Update Card Function (Class method) ---
    updateCard(cardElement, selectedVariantData) {
      console.log('updateCard called for variant:', selectedVariantData?.id, 'Data:', selectedVariantData);
      if (!selectedVariantData || !cardElement) {
        console.error('updateCard called with invalid data or card element');
        return;
      }

      // Update Image
      const img = cardElement.querySelector('[data-main-image]');
      if (img) {
        if (selectedVariantData.image_src) {
          console.log('Updating image src to:', selectedVariantData.image_src);
          img.src = selectedVariantData.image_src;
          img.alt = selectedVariantData.image_alt || '';
          // Optional: Add fade effect
          img.style.opacity = 0;
          setTimeout(() => { img.style.opacity = 1; }, 50); // Small delay for fade-in
        } else {
          console.warn('No image_src found in variant data for image update.');
           img.src = '{{ "product-1" | placeholder_svg_tag }}'; // Placeholder
           img.alt = 'Placeholder image';
        }
      } else {
        console.warn('Image element [data-main-image] not found.');
      }

      // Update Price
      const priceWrapper = cardElement.querySelector('[data-price-display]');
      if (priceWrapper) {
        const currentPriceFormatted = this.formatMoney(selectedVariantData.price);
        let priceHTML = `<p class="price">${currentPriceFormatted}`;

        if (selectedVariantData.compare_at_price && Number(selectedVariantData.compare_at_price) > Number(selectedVariantData.price)) {
          const comparePriceFormatted = this.formatMoney(selectedVariantData.compare_at_price);
          priceHTML += ` <del>${comparePriceFormatted}</del>`;
        }

        priceHTML += `</p>`;
        console.log('Updating price display HTML to:', priceHTML);
        priceWrapper.innerHTML = priceHTML;
      } else {
        console.warn('Price element [data-price-display] not found.');
      }

      // Update Discount Badge
      const badgeContainer = cardElement.querySelector('[data-badge-container]');
      const badgeText = cardElement.querySelector('[data-badge-text]');
      if (badgeContainer && badgeText) {
        const discount = this.calculateDiscount(selectedVariantData.price, selectedVariantData.compare_at_price);
        if (discount > 0) {
          console.log(`Applying visible badge with text: ${discount}% OFF`);
          badgeText.textContent = `${discount}% OFF`; // Or just discount%
          badgeContainer.classList.add('visible');
        } else {
          console.log('Hiding badge (discount <= 0).');
          badgeText.textContent = '';
          badgeContainer.classList.remove('visible');
        }
      } else {
        console.warn('Badge container [data-badge-container] or text [data-badge-text] element not found.');
      }

      // Update Buy Button data-variant-id (href might not be needed if using modal)
      const buyButton = cardElement.querySelector('.product-gallery-card__button'); // Target the actual button
      if (buyButton) {
        // We update the onclick in handleSwatchClick now, no need to update href if it opens a modal
        console.log('Buy button variant ID association updated (via onclick update)');
      } else {
        console.warn('Buy button .product-gallery-card__button not found.');
      }
    }

    handleSizeChange() {
      // Keep this method if the .price-offers logic is still relevant
      console.log('handleSizeChange called - implement logic if needed');
      if (!this.priceWrappers || this.priceWrappers.length === 0) return;
      this.priceWrappers.forEach((wrapper) => {
        const wrapperRect = wrapper.getBoundingClientRect();
        const price = wrapper.querySelector('.price');
        if (!price) return;
        const priceRect = price.getBoundingClientRect();
        const diff = wrapperRect.width - priceRect.width;
        const target = wrapper.querySelector('.price-offers');
         if (!target) return;

        if (diff < this.minDiff) {
          const newDiff = this.minDiff - diff;
          const right = -28 + newDiff / 2;
          target.style.right = `${right}px`;
        } else {
          target.style.right = `-28px`;
        }
      });
    }

    initEvent() {
       // Use the throttled function
      const throttledResizeHandler = ljThrottle(this.handleSizeChange, 500);
      window.addEventListener('resize', throttledResizeHandler);
      console.log('Resize event listener initialized.');
    }

    // Removed initSwiper as it's not used in this component's logic
  }

  // Define the custom element if it hasn't been defined already
  if (!customElements.get('activity-product-card')) {
     customElements.define('activity-product-card', PromptProductCard);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["activity-product-gallery"] && !Shopify.designMode) return;
  try {
    
// 确保脚本只运行一次
if (!window.ActivityProductGalleryInitialized) {
window.ActivityProductGalleryInitialized = true;

// Guard against redefining the element
if (!window.customElements.get('activity-product-gallery')) {
  class ActivityProductGallery extends HTMLElement {
    constructor() {
      super();
      console.log('ActivityProductGallery constructor');
      // 不使用 Shadow DOM
    }

    connectedCallback() {
      console.log('ActivityProductGallery connectedCallback');
      // 使用 requestAnimationFrame 确保 DOM 元素已准备好
      requestAnimationFrame(() => {
           this.initGallery();
      });
    }

    initGallery() {
      const productCards = this.querySelectorAll('li[data-product-id]');
      console.log('Found product cards inside custom element:', productCards.length);

      if (productCards.length === 0) {
        console.warn('No product cards found within activity-product-gallery.');
        return;
      }

      productCards.forEach((card) => {
        const productId = card.dataset.productId;
        const swatchesContainer = card.querySelector('[data-color-swatches]');
        const variantJsonScript = card.querySelector(`script[data-variant-json="${productId}"]`);
        const productCardElement = card.querySelector('.product-gallery-card'); // 卡片元素

        let variantsData = [];

        console.log(`Processing card ${productId}`);

        if (!productCardElement) {
           console.error('Could not find .product-gallery-card inside li for product', productId);
           return; // 跳过此卡片
        }

        if (variantJsonScript) {
          try {
            variantsData = JSON.parse(variantJsonScript.textContent);
            console.log(`Parsed ${variantsData.length} variants for product ${productId}`);
            // 将变体数据附加到卡片元素以便访问
            productCardElement.variantsData = variantsData;
          } catch (e) {
            console.error(`Error parsing variant JSON for product ${productId}:`, e);
            return; // 跳过此卡片
          }
        } else {
          console.warn(`Variant JSON script not found for product ${productId}`);
          return; // 跳过此卡片
        }

        // --- 初始卡片状态设置 ---
         // 查找初始激活的 swatch (基于 Liquid 渲染)
         const initiallyActiveSwatch = swatchesContainer ? swatchesContainer.querySelector('.color-swatch.active') : null;
         let initialVariantId = initiallyActiveSwatch ? initiallyActiveSwatch.dataset.variantId : null;
         let initialVariant = null;

          // 如果找到初始激活的 swatch ID，则查找对应的变体数据
         if (initialVariantId) {
             initialVariant = variantsData.find((v) => v.id == initialVariantId);
              console.log(`Found initially active swatch for variant ${initialVariantId}`);
         }

          // 如果没有找到初始激活的变体，或者该变体不可用，则查找第一个可用的变体
         if (!initialVariant || !initialVariant.available) {
             console.warn(`Initial variant ${initialVariantId} not found or unavailable. Finding first available variant for product ${productId}.`);
             initialVariant = variantsData.find(v => v.available);
         }

         // 如果仍然没有找到（例如所有变体都不可用），则使用第一个变体作为后备
         if (!initialVariant && variantsData.length > 0) {
              console.warn(`No available variants found for product ${productId}. Using first variant as fallback.`);
             initialVariant = variantsData[0];
         }


        if (initialVariant) {
          console.log(`Initial update for product ${productId} with variant ${initialVariant.id}`);
          this.updateCard(productCardElement, initialVariant);
          // 如果初始变体与 Liquid 渲染的激活 swatch 不符，更新 swatch 激活状态
          if(swatchesContainer && (!initiallyActiveSwatch || initiallyActiveSwatch.dataset.variantId != initialVariant.id)) {
               swatchesContainer.querySelectorAll('.color-swatch').forEach(sw => sw.classList.remove('active'));
               const correctSwatch = swatchesContainer.querySelector(`.color-swatch[data-color-handle="${initialVariant.color_handle}"]`);
               if (correctSwatch) {
                   correctSwatch.classList.add('active');
                   console.log(`Corrected active swatch for initial variant ${initialVariant.id}`);
               }
          }

        } else {
          console.error(`Could not determine an initial variant for product ${productId}.`);
        }


        // --- 添加事件监听器 ---
        if (swatchesContainer && variantsData.length > 0) {
          console.log(`Adding click listener to swatches for product ${productId}`);
          // 确保只添加一次监听器
           if (!swatchesContainer.hasClickListener) {
              swatchesContainer.addEventListener('click', this.handleSwatchClick.bind(this));
              swatchesContainer.hasClickListener = true; // 标记已添加
           }
        } else {
          console.warn(`No swatches container or variant data for product ${productId}, listener not added.`);
        }
      });
    }

    // --- Swatch 点击事件处理 ---
    handleSwatchClick(event) {
      const targetSwatch = event.target.closest('.color-swatch');
      if (!targetSwatch) return;

      const clickedColorHandle = targetSwatch.dataset.colorHandle;
      const swatchesContainer = targetSwatch.closest('[data-color-swatches]');
      const productCardElement = targetSwatch.closest('.product-gallery-card');

      if (!productCardElement || !productCardElement.variantsData || !swatchesContainer) {
         console.error('Swatch click: Missing data or elements.');
         return;
      }

      console.log(`Swatch clicked! Color Handle: ${clickedColorHandle}`);

       // 查找与点击的颜色 handle 匹配的 *第一个可用* 变体
       let selectedVariantData = productCardElement.variantsData.find(
           v => v.color_handle === clickedColorHandle && v.available
       );

      // 如果找不到可用的，则查找第一个匹配该颜色 handle 的变体（无论是否可用）
       if (!selectedVariantData) {
           selectedVariantData = productCardElement.variantsData.find(
               v => v.color_handle === clickedColorHandle
          );
          console.warn(`No available variant found for color ${clickedColorHandle}. Displaying first matching variant.`);
       }


      if (selectedVariantData) {
        console.log('Found variant data:', selectedVariantData);

        // 更新 active class
        swatchesContainer.querySelectorAll('.color-swatch').forEach((sw) => sw.classList.remove('active'));
        targetSwatch.classList.add('active');
        console.log('Active class updated.');

        // 更新卡片内容
        this.updateCard(productCardElement, selectedVariantData);
      } else {
        console.warn(`Could not find any variant data for color handle: ${clickedColorHandle}`);
      }
    }

    // --- 格式化货币 ---
    formatMoney(cents, format) {
      if (typeof cents == 'string') {
          // 移除除了数字和小数点之外的所有字符
          cents = cents.replace(/[^\d.]/g, '');
          // 如果包含小数点，则假设它是以元为单位的，将其转换为分
          if (cents.includes('.')) {
              cents = Math.round(parseFloat(cents) * 100);
          } else {
              // 否则假设它已经是分
              cents = parseInt(cents, 10);
          }
      }

       if (isNaN(cents)) {
           return ''; // 或者返回一个默认值如 '$0.00'
       }


      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      // 优先使用全局的 Shopify 格式，否则使用默认格式
      const formatString = format || window.Shopify?.money_format || '${{amount}}'; // 

      function defaultOption(opt, def) {
        return typeof opt == 'undefined' ? def : opt;
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ',');
          decimal = defaultOption(decimal, '.');

          if (isNaN(number) || number == null) {
              return '0';
          }

          // 将分转换为元，并应用精度
          number = (number / 100.0).toFixed(precision);

          const parts = number.split('.');
          const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
          const cents = parts[1] ? decimal + parts[1] : '';

          return dollars + cents;
      }


       // 从格式字符串中提取 amount 类型
       let amountType = 'amount'; // 默认类型
       const match = formatString.match(placeholderRegex);
       if (match && match[1]) {
           amountType = match[1]; // 如 'amount', 'amount_no_decimals' 等
       }


      switch (amountType) {
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
           value = formatWithDelimiters(cents, 0, ' ', '.');
           break;
        case 'amount_with_space_separator':
           value = formatWithDelimiters(cents, 2, ' ', '.');
           break;
         case 'amount_with_apostrophe_separator':
             value = formatWithDelimiters(cents, 2, "'", '.');
             break;
        // 默认处理 'amount' 以及其他未明确列出的情况
        case 'amount':
        default:
          value = formatWithDelimiters(cents, 2);
          break;
      }

       // 替换格式字符串中的占位符
       // 使用 amountType 来构建正则表达式，以防格式字符串变体
       const replaceRegex = new RegExp(`\\{\\{\\s*${amountType}\\s*\\}\\}`);
       return formatString.replace(replaceRegex, value);
    }


    // --- 计算折扣 ---
    calculateDiscount(price, compareAtPrice) {
      const numPrice = Number(price);
      const numCompareAtPrice = Number(compareAtPrice);

      if (
        !isNaN(numCompareAtPrice) && numCompareAtPrice > 0 &&
        !isNaN(numPrice) &&
        numCompareAtPrice > numPrice
      ) {
        const diff = numCompareAtPrice - numPrice;
        const discount = Math.floor((diff * 100) / numCompareAtPrice);
        return discount;
      }
      return 0; // 没有有效折扣
    }

    // --- 更新卡片内容 ---
    updateCard(cardElement, selectedVariantData) {
      console.log('updateCard called for variant:', selectedVariantData?.id, 'Data:', selectedVariantData);
      if (!selectedVariantData || !cardElement) {
        console.error('updateCard called with invalid data or card element');
        return;
      }

      // 更新图片
      const img = cardElement.querySelector('[data-main-image]');
      if (img) {
        if (selectedVariantData.image_src) {
          if(img.src !== selectedVariantData.image_src) { // 仅在 URL 不同时更新
              console.log('Updating image src to:', selectedVariantData.image_src);
              img.src = selectedVariantData.image_src;
              img.alt = selectedVariantData.image_alt || '';
          }
        } else {
          // 如果变体没有图片，可以考虑显示产品主图或占位符
          const productImgSrc = cardElement.querySelector('.product-gallery-card__image-wrapper img')?.dataset.defaultSrc; // 假设有默认图片 URL
          if (productImgSrc && img.src !== productImgSrc) {
               img.src = productImgSrc;
               img.alt = cardElement.querySelector('.product-gallery-card__title')?.textContent || 'Product image';
               console.warn(`Variant ${selectedVariantData.id} has no image, showing default product image.`);
          } else {
              console.warn(`Variant ${selectedVariantData.id} has no image, and no default image found.`);
          }
        }
      } else {
        console.warn('Image element [data-main-image] not found.');
      }

      // 更新价格
      const priceWrapper = cardElement.querySelector('[data-price-display]');
      if (priceWrapper) {
        const currentPriceFormatted = this.formatMoney(selectedVariantData.price);
        let priceHTML = `<p class="price">${currentPriceFormatted}`;
        if (
          selectedVariantData.compare_at_price &&
          Number(selectedVariantData.compare_at_price) > Number(selectedVariantData.price)
        ) {
          const comparePriceFormatted = this.formatMoney(selectedVariantData.compare_at_price);
          priceHTML += ` <del>${comparePriceFormatted}</del>`;
        }
        priceHTML += `</p>`;
        // 仅当内容改变时才更新 innerHTML，减少重绘
        if (priceWrapper.innerHTML !== priceHTML) {
           console.log('Updating price display HTML to:', priceHTML);
           priceWrapper.innerHTML = priceHTML;
        }
      } else {
        console.warn('Price element [data-price-display] not found.');
      }

      // 更新折扣角标
      const badgeContainer = cardElement.querySelector('[data-badge-container]');
      const badgeText = cardElement.querySelector('[data-badge-text]');
      if (badgeContainer && badgeText) {
        const discount = this.calculateDiscount(selectedVariantData.price, selectedVariantData.compare_at_price);
        if (discount > 0) {
          const badgeContent = `${discount}% OFF`; // 让 OFF 换行
           if(badgeContainer.innerHTML !== badgeContent) {
               badgeContainer.innerHTML = badgeContent;
           }
           if(!badgeContainer.classList.contains('visible')) {
              badgeContainer.classList.add('visible');
              console.log(`Applying visible badge with text: ${discount}% OFF`);
           }
        } else {
           if(badgeContainer.classList.contains('visible')) {
               badgeText.textContent = ''; // 清空内容
               badgeContainer.classList.remove('visible');
               console.log('Hiding badge (discount <= 0).');
           }
        }
      } else {
        console.warn('Badge container or text element not found.');
      }

      // 更新购买按钮 (例如更新 data-variant-id)
      const buyButton = cardElement.querySelector('[data-buy-button]');
      if (buyButton) {
        buyButton.dataset.selectedVariantId = selectedVariantData.id;
         // 如果按钮需要根据可用性禁用/启用
        // if (selectedVariantData.available) {
        //   buyButton.disabled = false;
        //   buyButton.querySelector('span').textContent = 'Buy Now';
        // } else {
        //   buyButton.disabled = true;
        //   buyButton.querySelector('span').textContent = 'Sold Out';
        // }
        console.log('Updated buy button selected variant ID to:', selectedVariantData.id);
      } else {
        console.warn('Buy button [data-buy-button] not found.');
      }
    }

    disconnectedCallback() {
      console.log('ActivityProductGallery disconnectedCallback');
      // 在元素移除时可以进行清理，例如移除事件监听器
       const swatchesContainers = this.querySelectorAll('[data-color-swatches]');
       swatchesContainers.forEach(container => {
           if (container.hasClickListener) {
               // container.removeEventListener('click', this.handleSwatchClick.bind(this)); // 移除监听器比较复杂，需要保存函数引用
               console.log('Listeners might need manual removal if element is frequently added/removed.');
           }
       });
    }
  }

  // --- 定义自定义元素 ---
  window.customElements.define('activity-product-gallery', ActivityProductGallery);
  console.log('Custom element "activity-product-gallery" defined.');

} else {
  console.log('Custom element "activity-product-gallery" already defined.');
   // 如果元素已定义，但页面动态加载了新的实例，可能需要手动初始化
   document.querySelectorAll('activity-product-gallery:not([initialized])').forEach(gallery => {
       if (gallery.initGallery) { // 检查方法是否存在
           requestAnimationFrame(() => {
               gallery.initGallery();
               gallery.setAttribute('initialized', 'true'); // 标记已初始化
          });
       }
   });
}

// --- 全局函数，供按钮调用打开模态框 ---
// 确保这个函数定义在全局作用域
if (typeof window.openProductModal === 'undefined') {
    window.openProductModal = function(productHandle) {
        console.log(`Attempting to open modal for product handle: ${productHandle}`);
        // 在这里添加打开你自定义模态框的逻辑
        // 例如:
        // const modal = document.getElementById('custom-product-modal');
        // const overlay = document.getElementById('custom-product-modal-overlay');
        // const loader = modal.querySelector('.custom-modal-loader');
        // const contentWrapper = modal.querySelector('.custom-modal-content-wrapper');
        //
        // if (modal && overlay && loader && contentWrapper) {
        //     overlay.removeAttribute('aria-hidden');
        //     modal.removeAttribute('aria-hidden');
        //     loader.style.display = 'block';
        //     contentWrapper.style.display = 'none'; // 隐藏旧内容
        //     document.body.style.overflow = 'hidden'; // 禁止背景滚动
        //
        //     // --- Fetch product data using AJAX ---
        //     fetch(`/products/${productHandle}?view=modal-content`) // 假设你创建了一个 modal-content.liquid 模板片段
        //         .then(response => response.text())
        //         .then(html => {
        //             // 用获取到的 HTML 更新模态框内容区域
        //             const tempDiv = document.createElement('div');
        //             tempDiv.innerHTML = html;
        //             const newContent = tempDiv.querySelector('.custom-modal-content-wrapper'); // 或者你的内容根元素选择器
        //             if (newContent) {
        //                  // 替换整个 wrapper 或仅替换其内部
        //                  contentWrapper.innerHTML = newContent.innerHTML;
        //                  // 更新完毕，隐藏加载动画，显示内容
                        //  loader.style.display = 'none';
                        //  contentWrapper.style.display = 'block'; // 或 flex 等
                        //  // 可能需要重新初始化模态框内的 JS (如 Swiper, 变体选择等)
                        //  // reinitializeModalScripts(modal);
        //             } else {
        //                  throw new Error('Modal content structure not found in response.');
        //             }
        //         })
        //         .catch(error => {
        //             console.error('Error loading product modal content:', error);
        //             loader.textContent = '加载失败，请稍后重试。'; // 显示错误信息
        //             // 可能需要提供关闭按钮
        //         });
        // } else {
        //     console.error('Modal elements not found!');
        // }
    };
}

} // end of ActivityProductGalleryInitialized check

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["activity-product-swiper"] && !Shopify.designMode) return;
  try {
    
  class ActivityProductSwiper extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      console.log('ActivityProductSwiper constructor');
    }

    connectedCallback() {
      console.log('ActivityProductSwiper connected');
      // 延迟初始化以确保 Swiper 库加载完毕且 DOM 稳定
      requestAnimationFrame(() => {
        if (typeof Swiper === 'undefined') {
          console.error('Swiper library is not loaded.');
          // 可选：在此处动态加载 Swiper 库
          return;
        }
        this.initSwiper();
      });
    }

    disconnectedCallback() {
      console.log('ActivityProductSwiper disconnected');
      // 销毁 Swiper 实例以释放资源
      if (this.swiper) {
        try {
          this.swiper.destroy(true, true);
          console.log('Swiper instance destroyed.');
        } catch (e) {
          console.error('Error destroying Swiper:', e);
        }
        this.swiper = null;
      }
    }

    initSwiper() {
      // 查找当前自定义元素内的 Swiper 容器
      const swiperContainer = this.querySelector('.product-swiper');

      if (!swiperContainer) {
        console.error('Swiper container (.product-swiper) not found within <activity-product-swiper>.');
        return;
      }
      // 检查是否有 slides，没有则不初始化
      const slides = swiperContainer.querySelectorAll('.swiper-slide');
      if (slides.length === 0) {
        const navPrev = swiperContainer.querySelector('.swiper-button-prev');
        const navNext = swiperContainer.querySelector('.swiper-button-next');
        const pagination = swiperContainer.querySelector('.swiper-pagination');
        if (navPrev) navPrev.style.display = 'none';
        if (navNext) navNext.style.display = 'none';
        if (pagination) pagination.style.display = 'none';
        return;
      }

      // 获取导航和分页元素
      const nextButton = swiperContainer.querySelector('.swiper-button-next');
      const prevButton = swiperContainer.querySelector('.swiper-button-prev');
      const paginationEl = swiperContainer.querySelector('.swiper-pagination');

      console.log('Initializing Swiper with container:', swiperContainer);

      // 初始化 Swiper
      this.swiper = new Swiper(swiperContainer, {
        loop: false, // 循环播放通常与 slidesPerView: 'auto' 结合不好
        autoplay: false, // 默认关闭自动播放
        spaceBetween: 50, // 调整 Slide 之间的间距 (可以根据需要减小)
        slidesPerView: 'auto', // 根据 Slide 宽度自动计算可见数量

        // --- 关键设置 ---
        slidesPerGroup: 1, // 每次导航只移动一个 slide
        watchOverflow: true, // 如果 slide 不足以滚动，则禁用导航和分页
        grabCursor: true, // 鼠标悬停时显示抓取手势
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        centeredSlides: false,
        slidesOffsetBefore: 0, // 从容器最左侧开始
        slidesOffsetAfter: 0, // 滑动到最右侧结束

        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        pagination: {
          el: paginationEl,
          clickable: true, // 允许点击分页器切换
        },
        keyboard: {
          enabled: true, // 启用键盘控制
          onlyInViewport: true, // 仅在 Swiper 在视口内时响应
        },
        observer: true, // 观察容器变化
        observeParents: true, // 观察父元素变化
        observeSlideChildren: true, // 观察 slide 子元素变化 (例如图片加载)

        // --- 响应式断点示例 (可选，需要根据设计调整) ---
        // breakpoints: {
        //    // 窗口宽度 >= 768px
        //    768: {
        //      spaceBetween: 40
        //    },
        //    // 窗口宽度 >= 992px
        //    992: {
        //       spaceBetween: 65,
        //       slidesPerView: 3 // 例如在中等屏幕固定显示3个
        //    },
        //     // 窗口宽度 >= 1200px
        //    1200: {
        //       spaceBetween: 65,
        //       slidesPerView: 4 // 例如在大屏幕固定显示4个
        //    }
        // }
      });
      console.log('Swiper initialized:', this.swiper);
    }
  }

  // 定义自定义元素（如果尚未定义）
  if (!window.customElements.get('activity-product-swiper')) {
    window.customElements.define('activity-product-swiper', ActivityProductSwiper);
    console.log('Custom element "activity-product-swiper" defined.');
  } else {
    console.log('Custom element "activity-product-swiper" already defined.');
    // 可选：如果需要在主题编辑器更新设置后重新初始化，可以在这里添加逻辑
    // document.querySelectorAll('activity-product-swiper').forEach(el => el.initSwiper());
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["activity-scene-list"] && !Shopify.designMode) return;
  try {
    
  class PromptSceneListWithHotspots extends HTMLElement {
    constructor() {
      super();
      const rawBlocksData = this.dataset.blocks || '[]';
      console.log(this.dataset.blocks)
      const rawProductsData = this.dataset.products || '{}';

      try {
        this.blocksData = JSON.parse(rawBlocksData);
      } catch (e) {
        console.error('解析 Block 数据失败:', e, rawBlocksData);
        this.blocksData = [];
      }
      try {
        this.productsData = JSON.parse(rawProductsData.trim());
      } catch (e) {
        console.error('解析 Product 数据失败:', e, rawProductsData);
        this.productsData = {};
      }

      this.sceneImages = Array.from(this.querySelectorAll('.scene-image'));
      this.hotspotContainer = this.querySelector('#hotspots-container');
      this.tooltipTemplate = this.querySelector('#product-tooltip-template');
      this.activeTooltip = null;
      this.activeBlockId = null;
      this.hideTimeoutId = null;

      this.mobileProductDisplay = this.querySelector('#mobile-product-display');
      this.mobileProductImage = this.querySelector('.mobile-product__image');
      this.mobileProductTitleText = this.querySelector('.mobile-product__title-text');
      this.mobileProductPrice = this.querySelector('.mobile-product__price');
      this.mobileProductNewBadge = this.querySelector('#mobile-product-display .new-badge');

      this.isMobile = window.innerWidth <= 768;
      this.handleResize = this._handleResize.bind(this);
    }

    connectedCallback() {
      if (
        !this.sceneImages.length ||
        !this.hotspotContainer ||
        !this.tooltipTemplate ||
        !this.mobileProductDisplay ||
        !this.mobileProductImage ||
        !this.mobileProductTitleText ||
        !this.mobileProductPrice
      ) {
        console.error('PromptSceneList 初始化失败: 缺少必要的 DOM 元素');
        return;
      }

      this.initButtonEvent();
      window.addEventListener('resize', this.handleResize);
      // 添加移动端价格点击事件
      if (this.mobileProductPrice) {
        this.mobileProductPrice.addEventListener('click', () => {
          if (this.activeBlockId) {
            const block = this.blocksData.find((b) => b.id?.toString() === this.activeBlockId);
            if (block && block.settings.product_handle) {
              if (typeof window.openProductModal === 'function') {
                window.openProductModal(block.settings.product_handle,"",this.dataset.producttype);
              }
            }
          }
        });
      }

      // 预加载所有图片后激活第一个block
      this._preloadImages().then(() => {
        this._updateLayout(true);
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
    }

    async _preloadImages() {
      const preloadPromises = this.sceneImages.map((img) => {
        return new Promise((resolve) => {
          if (img.complete) {
            resolve();
          } else {
            img.onload = resolve;
            img.onerror = resolve; // 即使加载失败也继续
          }
        });
      });

      await Promise.all(preloadPromises);
      console.log('所有图片预加载完成');
    }

    _handleResize() {
      const newIsMobile = window.innerWidth <= 768;
      if (newIsMobile !== this.isMobile) {
        this.isMobile = newIsMobile;
        this._updateLayout(false);
      }
    }

    _updateLayout(activateFirst = false) {
      if (this.isMobile) {
        if (this.activeTooltip) this.hideTooltip();
        this.clearHotspots();
      } else {
        if (this.mobileProductDisplay) this.mobileProductDisplay.style.display = 'none';
      }

      const blockToActivate = activateFirst ? this.blocksData[0]?.id ?? null : this.activeBlockId;

      if (blockToActivate) {
        this.activateBlock(blockToActivate);
      } else if (activateFirst) {
        console.warn('没有找到可激活的 Block');
        this.updateMobileProductDisplay(null);
      }
    }

    initButtonEvent() {
      const buttons = this.querySelectorAll('.button-wrapper button.switch');
      buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          const clickedButton = event.currentTarget;
          const blockId = clickedButton.dataset.blockId;
          if (blockId === this.activeBlockId) return;

          this.clearActiveStatus();
          clickedButton.classList.add('active');
          this.activateBlock(blockId);

          if (this.isMobile && typeof clickedButton.scrollIntoView === 'function') {
            clickedButton.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        });
      });
    }

    clearActiveStatus() {
      this.querySelectorAll('.button-wrapper button.switch').forEach((btn) => {
        btn.classList.remove('active');
      });
    }
    openProductModalFromDisplay() {
      if (!this.activeBlockId) return;

      const block = this.blocksData.find((b) => b.id?.toString() === this.activeBlockId);
      if (block && block.settings.product_handle) {
        this.hideTooltip(true); 
        openProductModal(block.settings.product_handle);
      }
    }
    activateBlock(blockId) {
      const targetBlockId = blockId?.toString();
      if (!targetBlockId) {
        console.warn('没有提供 block ID 进行激活');
        this.clearHotspots();
        this.updateMobileProductDisplay(null);
        return;
      }

      const block = this.blocksData.find((b) => b.id?.toString() === targetBlockId);
      if (!block || !block.settings) {
        console.warn(`未找到 ID 为 ${targetBlockId} 的 Block 数据`);
        this.clearActiveStatus();
        this.activeBlockId = null;
        this.clearHotspots();
        this.updateMobileProductDisplay(null);
        return;
      }

      this.activeBlockId = targetBlockId;
      console.log(`激活 Block ID: ${this.activeBlockId}, 是否移动端: ${this.isMobile}`);

      // 更新图片显示状态
      this.sceneImages.forEach((img) => {
        img.classList.remove('active');
        if (img.dataset.blockId === targetBlockId) {
          img.classList.add('active');
        }
      });

      // 更新热点或移动端显示
      if (this.isMobile) {
        this.updateMobileProductDisplay(block.settings.product_handle);
        this.clearHotspots();
        if (this.mobileProductDisplay) this.mobileProductDisplay.style.display = 'flex';
      } else {
        this.updateHotspot(block.settings, targetBlockId);
        if (this.mobileProductDisplay) this.mobileProductDisplay.style.display = 'none';
      }
    }

    updateHotspot(blockSettings, blockId) {
      if (this.isMobile) {
        this.clearHotspots();
        return;
      }

      this.clearHotspots();

      const productHandle = blockSettings?.product_handle;
      if (!productHandle || typeof productHandle !== 'string' || productHandle.trim() === '') {
        return;
      }
      if (!this.productsData[productHandle]) {
        console.warn(`找不到产品数据: ${productHandle}`);
        return;
      }
      const hasPosition = blockSettings?.hotspot_x != null && blockSettings?.hotspot_y != null;
      const productDataExists = productHandle && this.productsData[productHandle];

      if (hasPosition && productHandle && productHandle.trim() !== '' && productDataExists) {
        const hotspot = document.createElement('div');
        hotspot.className = 'hotspot';
        hotspot.style.left = `${blockSettings.hotspot_x}%`;
        hotspot.style.top = `${blockSettings.hotspot_y}%`;
        hotspot.dataset.productHandle = productHandle;
        hotspot.dataset.blockId = blockId;

        hotspot.addEventListener('mouseenter', (e) => {
          clearTimeout(this.hideTimeoutId);
          this.showTooltip(e.currentTarget);
        });
        hotspot.addEventListener('mouseleave', () => {
          this.hideTimeoutId = setTimeout(() => {
            this.hideTooltip();
          }, 200);
        });

        if (this.hotspotContainer) {
          this.hotspotContainer.appendChild(hotspot);
        }
      }
    }

    clearHotspots() {
      if (this.hotspotContainer) {
        this.hotspotContainer.innerHTML = '';
      }
      this.hideTooltip();
    }

    updateMobileProductDisplay(productHandle) {
      if (
        !this.mobileProductDisplay ||
        !this.mobileProductImage ||
        !this.mobileProductTitleText ||
        !this.mobileProductPrice ||
        !this.mobileProductNewBadge
      ) {
        if (this.mobileProductDisplay) this.mobileProductDisplay.style.display = 'none';
        return;
      }
      const handle = typeof productHandle === 'string' ? productHandle.trim() : '';
      const productData = handle && this.productsData[handle] ? this.productsData[handle] : null;

      if (productData) {
        this.mobileProductImage.src = productData.featured_image?.src || '';
        this.mobileProductImage.alt = productData.featured_image?.alt || productData.title || '产品图片';
        this.mobileProductTitleText.textContent = productData.title;
        const price = productData.price || '$0.00';
        this.mobileProductPrice.innerHTML = `${price}<span>></span>`;
        this.mobileProductNewBadge.style.display = 'inline-block';
        this.mobileProductDisplay.style.display = 'flex';
      } else {
        this.mobileProductDisplay.style.display = 'none';
      }
    }

    showTooltip(hotspotElement) {
      if (this.isMobile) {
        return;
      }

      const productHandle = hotspotElement?.dataset?.productHandle;
      if (!hotspotElement || !productHandle || !this.tooltipTemplate || !this.productsData[productHandle]) {
        this.hideTooltip();
        return;
      }

      const productData = this.productsData[productHandle];

      if (this.activeTooltip) {
        this.hideTooltip();
      }

      const tooltipClone = this.tooltipTemplate.content.cloneNode(true);
      const tooltip = tooltipClone.querySelector('.product-tooltip');
      if (!tooltip) {
        return;
      }
      this.appendChild(tooltip);

      const imgEl = tooltip.querySelector('.product-tooltip__image');
      const titleSpan = tooltip.querySelector('.product-tooltip__title span:last-child');
      const priceEl = tooltip.querySelector('.product-tooltip__price');
      const newBadgeEl = tooltip.querySelector('.new-badge');

      if (imgEl) {
        imgEl.src = productData.featured_image?.src || '';
        imgEl.alt = productData.featured_image?.alt || productData.title || '';
      }
      if (titleSpan) titleSpan.textContent = productData.title;
      let priceHTML = `${productData.price}<span>></span>`;
      if (priceEl) priceEl.innerHTML = priceHTML;
      if (newBadgeEl) {
        newBadgeEl.style.display = 'inline-block';
      }

      if (priceEl) {
        priceEl.style.cursor = 'pointer';
        priceEl.addEventListener('click', (event) => {
          event.preventDefault(); 
          const handleToOpen = productHandle; 
          this.hideTooltip(true); 
          setTimeout(() => {
            if (typeof window.openProductModal === 'function') {
              window.openProductModal(handleToOpen,"",this.dataset.producttype);
            } else {
              console.error('window.openProductModal 函数未找到!');
            }
          }, 1000);
        });
      }

      const hotspotRect = hotspotElement.getBoundingClientRect();
      const containerRect = this.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      const tooltipWidth = tooltip.offsetWidth || 280;
      const tooltipHeight = tooltip.offsetHeight || 120;
      const offset = 10;

      let top = hotspotRect.bottom + window.scrollY + offset;
      let left = hotspotRect.left + window.scrollX + hotspotRect.width / 2 - tooltipWidth / 2;

      if (top + tooltipHeight > viewportHeight + window.scrollY - offset) {
        top = hotspotRect.top + window.scrollY - tooltipHeight - offset;
      }
      top = Math.max(window.scrollY + offset, top);

      left = Math.max(window.scrollX + offset, left);
      left = Math.min(window.scrollX + viewportWidth - tooltipWidth - offset, left);

      tooltip.style.position = 'absolute';
      tooltip.style.top = `${top}px`;
      tooltip.style.left = `${left}px`;

      tooltip.dataset.productHandle = productHandle;
      tooltip.addEventListener('mouseenter', () => {
        clearTimeout(this.hideTimeoutId);
      });
      tooltip.addEventListener('mouseleave', () => {
        this.hideTimeoutId = setTimeout(() => {
          this.hideTooltip();
        }, 200);
      });

      this.activeTooltip = tooltip;
      requestAnimationFrame(() => {
        tooltip.classList.add('visible');
      });
    }

    hideTooltip() {
      if (this.activeTooltip) {
        const currentTooltip = this.activeTooltip;
        this.activeTooltip = null;

        currentTooltip.classList.remove('visible');

        const removeTooltip = () => {
          if (currentTooltip && currentTooltip.parentNode === this) {
            currentTooltip.remove();
          }
        };

        currentTooltip.addEventListener('transitionend', removeTooltip, { once: true });
        setTimeout(removeTooltip, 350);
      }
    }
  }

  if (!customElements.get('activity-scene-list')) {
    customElements.define('activity-scene-list', PromptSceneListWithHotspots);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portable-header"] && !Shopify.designMode) return;
  try {
    
  var PromptHeader = class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {}
  };
  if (!window.customElements.get('prompt-header')) {
    window.customElements.define('prompt-header', PromptHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portable-product-card"] && !Shopify.designMode) return;
  try {
    
  function ljThrottle(func, delay) {
    let timer = null;
    return function () {
      const context = this;
      const args = arguments;
      if (!timer) {
        timer = setTimeout(() => {
          func.apply(context, args);
          timer = null;
        }, delay);
      }
    };
  }
  class PromptProductCard extends HTMLElement {
    constructor() {
      super();
      this.swipers = new Map();
      this.priceWrappers = null;
      this.minDiff = 56;
      document.addEventListener('DOMContentLoaded', () => {
        this.handleSizeChange();
      });
    }

    connectedCallback() {
      window.addEventListener('load', () => {
        this.init(); // 调用初始化 Swiper 的方法
        this.handleSizeChange(); // 确保其他依赖尺寸的逻辑也更新

        // 遍历所有 Swiper 实例并强制更新其布局
        this.swipers.forEach((swiperSet) => {
          if (swiperSet.main) {
            console.log(`--- Swiper ${swiperSet.main.el.className} Before Update ---`);
            console.log('Swiper params.width:', swiperSet.main.params.width);
            console.log('Swiper width:', swiperSet.main.width);
            swiperSet.main.slides.forEach((slide, index) => {
              console.log(`Slide ${index} clientWidth:`, slide.clientWidth);
              console.log(`Slide ${index} offsetWidth:`, slide.offsetWidth);
              const img = slide.querySelector('img');
              if (img) {
                console.log(`Image ${index} naturalWidth:`, img.naturalWidth);
                console.log(`Image ${index} naturalHeight:`, img.naturalHeight);
                console.log(`Image ${index} clientWidth:`, img.clientWidth);
                console.log(`Image ${index} offsetWidth:`, img.offsetWidth);
              }
            });
            console.log(`--- Swiper ${swiperSet.main.el.className} After Update ---`);
            swiperSet.main.update();
            console.log('Swiper width after update:', swiperSet.main.width);
            // 再次检查幻灯片宽度
            swiperSet.main.slides.forEach((slide, index) => {
              console.log(`Slide ${index} clientWidth after update:`, slide.clientWidth);
            });
          }
        });
      });
    }

    init() {
      this.querySelectorAll('.product-card').forEach((card) => {
        const blockId = card.dataset.blockId;
        if (card.querySelector('.swiper-wrapper').children.length > 0) {
          this.initSwiper(blockId);
        }
      });
      this.initEvent();
      this.priceWrappers = document.querySelectorAll('.price-offers-wrapper');
    }
    handleSizeChange() {
      if (!this.priceWrappers) return;
      this.priceWrappers.forEach((wrapper) => {
        const wrapperRect = wrapper.getBoundingClientRect();
        const price = wrapper.querySelector('.price');
        const priceRect = price.getBoundingClientRect();
        const diff = wrapperRect.width - priceRect.width;
        const target = wrapper.querySelector('.price-offers');
        if (diff < this.minDiff) {
          const newDiff = this.minDiff - diff;
          const right = -28 + newDiff / 2;
          target.style.right = `${right}px`;
        } else {
          target.style.right = `-28px`;
        }
      });
    }
    initEvent() {
      const handleSizeChange = ljThrottle(this.handleSizeChange.bind(this), 500);
      window.addEventListener('resize', handleSizeChange);
    }

    initSwiper(blockId) {
      const thumbsSwiper = new Swiper(`.thumb-swiper-${blockId}`, {
        direction: this.dataset.thumb_position === 'left' ? 'vertical' : 'horizontal',
        spaceBetween: 5,
        slidesPerView: 4,
        watchSlidesVisibility: true,
        freeMode: true,
        watchSlidesProgress: true,
      });

      const mainSwiper = new Swiper(`.prompt-swiper-${blockId}`, {
        spaceBetween: 10,
        loop: false,
        slidesPerView: 'auto',
        navigation: {
          nextEl: `.prompt-swiper-${blockId} .swiper-button-next`,
          prevEl: `.prompt-swiper-${blockId} .swiper-button-prev`,
        },
        pagination: {
          el: `.prompt-swiper-${blockId} .swiper-pagination`,
          clickable: true,
        },
        thumbs: {
          swiper: thumbsSwiper,
          autoScrollOffset: 1,
        },
      });

      this.swipers.set(blockId, {
        main: mainSwiper,
        thumbs: thumbsSwiper,
      });
    }
  }
  customElements.define('portable-product-card', PromptProductCard);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prompt-faq"] && !Shopify.designMode) return;
  try {
    
  class PromptFAQ extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initEvent();
    }

    initEvent() {
      const faqList = this.querySelector('.faq-list')
      if (! faqList) return


      


      faqList.addEventListener('click', (event) => {
        const currentRow = event.target.closest('.row')

// 如果点击的不是row或其子元素，直接返回
        if (! currentRow) return


        


// 关闭其他所有展开的行
        const previouslyOpenRow = faqList
        .querySelector('.row.active')
          if (previouslyOpenRow && previouslyOpenRow !== currentRow) {
            previouslyOpenRow
              .classList
              .remove('active')
              previouslyOpenRow
              .querySelector('.answer')
              .classList
              .remove('show')

  // 显示加号，隐藏减号
            previouslyOpenRow
            .querySelectorAll('.icon-right')
            .forEach(icon => {
              icon.classList.toggle('hide', !icon.classList.contains('hide'))
            })
        }

  // 切换当前行的状态
        currentRow
        .classList
        .toggle('active')
        currentRow
        .querySelector('.answer')
        .classList
        .toggle('show')

// 切换加号和减号的显示状态
      currentRow
      .querySelectorAll('.icon-right')
      .forEach(icon => {
        icon.classList.toggle('hide')
      })
  })
}}if (!window.customElements.get('prompt-faq')) {
customElements.define('prompt-faq', PromptFAQ);}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prompt-header"] && !Shopify.designMode) return;
  try {
    
  var PromptHeader = class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {}
  }
  if (!window.customElements.get('prompt-header')) {
    window.customElements.define('prompt-header', PromptHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prompt-main-slide"] && !Shopify.designMode) return;
  try {
    
  var PromptMainSlider = class extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    isMobile() {
      const mediaQuery = '(max-width: 768px)';
      const mql = window.matchMedia(mediaQuery);

      if (mql.matches) {
        return true;
      } else {
        return false;
      }
    }

    initSwiper() {
      let id = this.getAttribute('section-id');
      let className = '.pc-swiper-' + id;
      let paginationClassname = '.pc-pagination-' + id;
      if (this.isMobile()) {
        className = '.mobile-swiper-' + id;
        paginationClassname = '.mobile-pagination-' + id;
      }
      const speed = this.dataset.speed
      this.swiper = new Swiper(className, {
        loop: true,
        autoplay: {
          delay: speed * 1000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        spaceBetween: 20,
        slidesPerView: 'auto',
        pagination: {
          el: paginationClassname,
          clickable: true,
        },
        on: {
          slideChangeTransitionEnd: function () {
            // 获取当前激活的slide
            const activeSlide = this.slides[this.activeIndex];
            // 获取按钮文本
            const btnText = activeSlide.getAttribute('data-btntext');
            // 获取对应的button元素并更新内容
            const button = activeSlide.closest('.swiper').querySelector('.prompt-button span');
            if (button && btnText) {
              button.textContent = btnText;
            }
          }
        }
      });
    }

    initBuyButton() {
      const buyButtons = this.querySelectorAll('button.prompt-button');
      const _this = this;
      for(const buyButton of buyButtons){
        buyButton.addEventListener('click', function () {
          const curr = _this.swiper.slides[_this.swiper.activeIndex];
          const link = curr.getAttribute('link');
          window.location.href = link;
        });
      }
    }

    connectedCallback() {
      this.initSwiper();
      this.initBuyButton();
    }
  };
  if (!window.customElements.get('prompt-main-slide')) {
    window.customElements.define('prompt-main-slide', PromptMainSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prompt-picture-swiper"] && !Shopify.designMode) return;
  try {
    
  class PromptPictureSwiper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const selector = `.swiper-${this.dataset.sectionid}`;
      this.swiper = new Swiper(selector, {
        loop: true,
        autoplay: {
          delay: 1000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        spaceBetween: 20,
        slidesPerView: 'auto',
      });
    }
  }
  if (!window.customElements.get('prompt-picture-swiper')) {
    window.customElements.define('prompt-picture-swiper', PromptPictureSwiper);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prompt-product-card"] && !Shopify.designMode) return;
  try {
    
  function ljThrottle(func, delay) {
      let timer = null;
      return function() {
          const context = this;
          const args = arguments;
          if (!timer) {
              timer = setTimeout(() => {
                  func.apply(context, args);
                  timer = null;
              }, delay);
          }
      };
  }
  class PromptProductCard extends HTMLElement {
    constructor() {
      super();
      this.swipers = new Map();
      this.priceWrappers = null
      this.minDiff = 56
      document.addEventListener('DOMContentLoaded', () => {
        this.handleSizeChange()
      });
    }

    connectedCallback(){
        this.init();
    }

    init() {
      this.querySelectorAll('.product-card').forEach((card) => {
        const blockId = card.dataset.blockId;
        if (card.querySelector('.swiper-wrapper').children.length > 0) {
          this.initSwiper(blockId);
        }
      });
      this.initEvent()
      this.priceWrappers = document.querySelectorAll('.price-offers-wrapper')
    
    }
    handleSizeChange(){
        if(!this.priceWrappers) return
        this.priceWrappers.forEach((wrapper)=>{
            const wrapperRect = wrapper.getBoundingClientRect()
            const price = wrapper.querySelector('.price')
            const priceRect = price.getBoundingClientRect()
            const diff = wrapperRect.width - priceRect.width
            const target = wrapper.querySelector(".price-offers")
            if(diff < this.minDiff){
                const newDiff = this.minDiff - diff
                const right = -28 + newDiff/2
                target.style.right = `${right}px`
            }else{
                target.style.right = `-28px`
            }
        })
    }
    initEvent(){
        const handleSizeChange = ljThrottle(this.handleSizeChange.bind(this), 500)
        window.addEventListener('resize', handleSizeChange)
    }

    initSwiper(blockId) {
      const thumbsSwiper = new Swiper(`.thumb-swiper-${blockId}`, {
        direction: this.dataset.thumb_position === 'left' ? 'vertical' : 'horizontal',
        spaceBetween: 5,
        slidesPerView: 4,
        watchSlidesVisibility: true,
        freeMode: true,
        watchSlidesProgress: true,
      });

      const mainSwiper = new Swiper(`.prompt-swiper-${blockId}`, {
        spaceBetween: 10,
        loop: false,
        navigation: {
          nextEl: `.prompt-swiper-${blockId} .swiper-button-next`,
          prevEl: `.prompt-swiper-${blockId} .swiper-button-prev`,
        },
        pagination: {
          el: `.prompt-swiper-${blockId} .swiper-pagination`,
          clickable: true,
        },
        thumbs: {
          swiper: thumbsSwiper,
          autoScrollOffset: 1,
        },
      });

      this.swipers.set(blockId, {
        main: mainSwiper,
        thumbs: thumbsSwiper,
      });
    }
  }
  customElements.define('prompt-product-card', PromptProductCard);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prompt-review-slide"] && !Shopify.designMode) return;
  try {
    
  var PromptReviewList = class extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    isMobile() {
      const mediaQuery = '(max-width: 768px)';
      const mql = window.matchMedia(mediaQuery);

      if (mql.matches) {
        return true;
      } else {
        return false;
      }
    }

    initSwiper() {
      let id = this.getAttribute('section-id');
      let className = '.pc-swiper-' + id;
      let paginationClassname = '.pagination-' + id;
      this.swiper = new Swiper(className, {
        loop: true,
        spaceBetween: 20,
        slidesPerView: 'auto',
        pagination: {
          el: paginationClassname,
          clickable: true,
        },
        autoplay: {
          delay: 30000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    }

    connectedCallback() {
      this.initSwiper();
    }
  };
  if (!window.customElements.get('prompt-review-slide')) {
    window.customElements.define('prompt-review-slide', PromptReviewList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prompt-simple-product-card"] && !Shopify.designMode) return;
  try {
    
  class PromptSimpleProductCard extends HTMLElement {
    constructor() {
      super();
    }
  }
  customElements.define('prompt-simple-product-card', PromptSimpleProductCard);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prompt-two-pictures"] && !Shopify.designMode) return;
  try {
    
  var PromptTwoPictures = class PromptTwoPictures extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
        this.initSwiper()
    }
    initSwiper() {
      let id = this.getAttribute('section-id');
      let className = '.swiper-' + id;
      this.swiper = new Swiper(className, {
        autoplay: {
          reverseDirection: true,
          waitForTransition: true,
          delay: 1000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
          pauseOnMouseEnter: true,
        },
        spaceBetween: 20,
        slidesPerView: 'auto',
      });
    }
  };
  if (!window.customElements.get('prompt-two-pictures')) {
    window.customElements.define('prompt-two-pictures', PromptTwoPictures);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prompt-video-list"] && !Shopify.designMode) return;
  try {
    
  // 定义一个函数来检查元素的祖先元素是否 display: none
  function hasHiddenAncestor(element) {
    // 获取元素的父元素
    let parent = element.parentElement;
    // 当父元素存在时进行循环检查
    while (parent) {
      // 获取父元素的计算样式
      const computedStyle = window.getComputedStyle(parent);
      // 检查父元素的 display 属性值是否为 none
      if (computedStyle.display === 'none') {
        return true;
      }
      // 获取下一个父元素
      parent = parent.parentElement;
    }
    return false;
  }

  var PromptVideoList = class PromptVideoList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initButtonEvent();
      this.initLink();
    }
    initLink() {
      const buttons = this.querySelectorAll('ul.button-wrapper button.switch');
      if (!buttons || buttons.length < 1) return;
      const button = buttons[0];
      button.classList.add('active');
    }
    clearActiveStatus() {
      const buttons = this.querySelectorAll('ul.button-wrapper button.switch');
      if (!buttons || buttons.length < 1) return;
      buttons.forEach(function (btn) {
        btn.classList.remove('active');
      });
    }
    initButtonEvent() {
      const ul = this.querySelector('ul.button-wrapper');
      const _this = this;
      ul.addEventListener('click', function (event) {
        if (!event.target.tagName || event.target.tagName.toUpperCase() !== 'SPAN') {
          return;
        }
        _this.clearActiveStatus();
        const button = event.target.parentElement
        button.classList.add('active');
        const video_id = button.getAttribute('data-video-id');
        if (!video_id) return;
        const iframes = _this.querySelectorAll('iframe')
        iframes.forEach(function(iframe){
            iframe.src =  'https://www.youtube.com/embed/' + video_id
        })
      });
    }
  };
  if (!window.customElements.get('prompt-video-list')) {
    window.customElements.define('prompt-video-list', PromptVideoList);
  }

  } catch(e) { console.error(e); }
})();
})();
